import type { CityConfig } from "../city-template/types";

export const northLibertyConfig: CityConfig = {
  city: "North Liberty",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "north-liberty",
  route: "/cities/north-liberty",
  title: "Emergency Passport North Liberty, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in North Liberty, IA — as fast as 24 hours. Serving Johnson County and the Iowa City metro. A+ BBB rated registered State Dept. courier serving Centennial Park, UIowa commuters, and tech corridor professionals. No office visit required.",
  h1: "Emergency & Expedited Passport Services in North Liberty, IA",
  heroSubtitle: "Tech corridor professional with a last-minute conference in Tokyo? Iowa City metro family planning a European vacation and the kids need passports? UIowa researcher heading to an international symposium and your documents aren't ready? We help North Liberty and Johnson County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=North%20Liberty%20Iowa%20suburban%20community%20Centennial%20Park%20modern%20residential%20neighborhoods%20green%20spaces%20community%20center%20Iowa%20City%20metro%20area%20golden%20hour%20warm%20sunlight%20professional%20aerial%20photography%20Midwest%20suburban%20charm&width=1800&height=700&seq=north-liberty-hero-ia-2026&orientation=landscape",
  heroImageAlt: "North Liberty Iowa Centennial Park and suburban community Iowa City metro at golden hour",
  geoPosition: "41.7500;-91.6000",
  geoPlacename: "North Liberty, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 235 miles east of North Liberty via I-80/I-88",
  },
  nearbyCitiesZips: [
    { name: "North Liberty", zips: "52317" },
    { name: "Coralville", zips: "52241" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Tiffin", zips: "52340" },
    { name: "Solon", zips: "52333" },
    { name: "Swisher", zips: "52338" },
    { name: "Oxford", zips: "52322" },
    { name: "West Branch", zips: "52358" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Marion", zips: "52302" },
    { name: "Mount Vernon", zips: "52314" },
    { name: "Lisbon", zips: "52253" },
    { name: "Williamsburg", zips: "52361" },
    { name: "Kalona", zips: "52247" },
    { name: "Washington", zips: "52353" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Waterloo", zips: "50701–50707" },
    { name: "Dubuque", zips: "52001–52004" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Johnson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Iowa City Metro Coverage", desc: "Serving North Liberty, Coralville, Tiffin, and Johnson County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Fast passport renewal in Coralville, IA", route: "/cities/coralville" },
    { name: "Emergency passport help in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Urgent passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Same-day passport help in Waterloo, IA", route: "/cities/waterloo-ia" },
    { name: "Passport courier services in Davenport, IA", route: "/cities/davenport" },
  ],
  fpcOfficeNote: "Fast Passport Center serves North Liberty remotely via secure courier. We do not have a walk-in office in North Liberty — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Johnson County and the entire Iowa City metro.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Johnson County and the Iowa City metro region including North Liberty, Coralville, Tiffin, and Solon",
  serviceAreaIntro: "From the growing Centennial Park neighborhoods and the tech corridor offices along I-380 to the family-friendly subdivisions of North Liberty, from the University of Iowa commuter communities to the quaint towns of Solon and Tiffin, from the commercial hub of Coralville to the academic heart of Iowa City — Fast Passport Center serves the entire North Liberty and Johnson County region. We regularly help travelers from North Liberty, Coralville, Iowa City, Tiffin, and Solon get their passports fast without the 4-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all North Liberty neighborhoods and the surrounding Iowa City metro area including Coralville, Iowa City, Tiffin, Solon, Swisher, Oxford, and West Branch. If you are anywhere in Johnson County or the I-380 corridor, we have you covered.",
  howItWorksIntro: "Most North Liberty travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Johnson County travelers often face a 4-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "North Liberty and Johnson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in North Liberty? Here are the most common ones we hear from Iowa City metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For North Liberty travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Rachel T.",
      location: "North Liberty, IA",
      rating: 5,
      text: "My tech company sent me to Singapore on 4 days notice for a client emergency. Fast Passport Center renewed my passport in 36 hours. I never left North Liberty. Unbelievable service for the tech corridor.",
      service: "Passport Renewal",
    },
    {
      name: "James K.",
      location: "North Liberty, IA",
      rating: 5,
      text: "UIowa research conference in Barcelona — I realized my passport was expired 5 days before my flight. Fast Passport Center got it done in 3 days. My department head now recommends them to every researcher.",
      service: "Emergency Passport",
    },
    {
      name: "The Mendez Family",
      location: "Tiffin, IA",
      rating: 5,
      text: "Family reunion in Mexico with the whole extended family. We needed 4 passports including two for our kids. Fast Passport Center handled everything in 6 days. Every single one arrived on time. Incredible.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "north-liberty-1",
      name: "North Liberty Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "620 Liberty Way",
      city: "North Liberty",
      state: "IA",
      zip: "52317",
      phone: "(319) 665-4111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown North Liberty",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary North Liberty facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "north-liberty-2",
      name: "Coralville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 1st Ave",
      city: "Coralville",
      state: "IA",
      zip: "52241",
      phone: "(319) 337-3354",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south in Coralville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full passport services serving Coralville. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "north-liberty-3",
      name: "Johnson County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "913 S Dubuque St",
      city: "Iowa City",
      state: "IA",
      zip: "52240",
      phone: "(319) 356-6061",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "10 miles south in Iowa City",
      website: "https://www.johnsoncountyiowa.gov/recorder",
      websiteLabel: "Johnson County Recorder",
      notes: "Accepts passport applications for Johnson County. Extended hours compared to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "north-liberty-4",
      name: "Iowa City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 S Clinton St",
      city: "Iowa City",
      state: "IA",
      zip: "52240",
      phone: "(319) 337-3354",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles south in Iowa City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full passport services in downtown Iowa City. Serves UIowa and surrounding area.",
      icon: "ri-mail-line",
    },
    {
      id: "north-liberty-5",
      name: "Cedar Rapids Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "615 6th Ave SE",
      city: "Cedar Rapids",
      state: "IA",
      zip: "52401",
      phone: "(319) 399-4411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles north in Cedar Rapids",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Linn County. Full passport services. Good alternative for northern Johnson County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "North Liberty photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Johnson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many North Liberty applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Johnson County families at the county recorder.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "North Liberty travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in North Liberty." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your North Liberty address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in North Liberty before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in North Liberty for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4-hour drive to Chicago." },
    { q: "How fast can I renew my passport in North Liberty?", a: "Fast Passport Center offers fast passport renewal in North Liberty in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to North Liberty?", a: "The nearest regional passport agency to North Liberty is the Chicago Passport Agency, approximately 235 miles east via I-80/I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from North Liberty without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near North Liberty?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4 hours from North Liberty — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Johnson County residents." },
    { q: "Do you serve the entire Iowa City metro area?", a: "Absolutely. Fast Passport Center serves the entire Iowa City metro and Johnson County including North Liberty, Coralville, Iowa City, Tiffin, Solon, and surrounding communities. Our courier service works seamlessly from any address in the I-380 corridor." },
    { q: "Can I expedite a child passport in North Liberty?", a: "Yes. Fast Passport Center expedites child passports in North Liberty for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Johnson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in North Liberty with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Coralville", address: "2801 Commerce Dr, Coralville, IA 52241", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Coralville", address: "102 2nd St, Coralville, IA 52241", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Iowa City", address: "201 S Clinton St, Iowa City, IA 52240", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Iowa City", address: "1001 N Dodge St, Iowa City, IA 52245", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Iowa City Driver's License",
      address: "1700 S 1st Ave, Iowa City, IA 52240",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Johnson County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Cedar Rapids Driver's License",
      address: "230 3rd Ave SW, Cedar Rapids, IA 52404",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Linn County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Washington Driver's License",
      address: "2185 Lexington Blvd, Washington, IA 52353",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Washington County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "15 miles north of North Liberty",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Regional airport with direct flights to major hubs. About 20 minutes from North Liberty via I-380.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: true,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "120 miles west of North Liberty",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 2 hours from North Liberty.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "75 miles east of North Liberty",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport with direct flights to major hubs. About 1 hour 20 minutes from North Liberty.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Iowa Department of Health and Human Services Vital Records in Des Moines — order certified birth and death certificates for Johnson County residents.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Johnson County Recorder — certified marriage licenses for name change passport applications.", url: "https://www.johnsoncountyiowa.gov/recorder" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Johnson County Clerk of Court — certified divorce decrees supporting passport name change.", url: "https://www.iowacourts.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "Order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};